import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarComponent } from '@vendasta/galaxy/avatar';
import { ProductIcon } from '../../../core/interfaces/config.interface';

@Component({
  selector: 'ai-capability-product-icon',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, TranslateModule, AvatarComponent],
  templateUrl: './capability-product-icon.component.html',
  styleUrl: './capability-product-icon.component.scss',
})
export class CapabilityProductIconComponent {
  isCustom = input<boolean>(false);
  productIcon = input<ProductIcon | undefined>();
}
